import styled from "styled-components";

export const ReviewRatingSection = styled.div`
  display: flex;
  justify-content: center;
  gap: 5px;
  margin-bottom: 2rem;

  @media (max-width: 540px) {
    gap: 5px;
  }
`;

export const ReviewRating = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  max-width: 20rem;
  .puc-icon,
  .google-icon {
    width: 90px;
    height: 90px;
  }
  p {
    gap: 8px;
    font-size: 15px;
    font-weight: 700;
    text-align: center;
    width: 100%;
    margin-bottom: 0;
    color: #000;
  }

  span {
    font-weight: 400;
  }

  @media (max-width: 768px) {
    p {
      font-size: 14px;
    }
  }

  @media (max-width: 540px) {
    gap: 5px;
    .puc-icon,
    .google-icon {
      width: 75px;
      height: 75px;
    }
  }
`;

export const Starts = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 10px;

  @media (max-width: 540px) {
    margin-bottom: 5px;
    img {
      width: 15px;
      height: 15px;
    }
  }
`;
